"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _dateHelper = require("../../../helpers/dateHelper");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _orderHistoryHelper = require("../../../helpers/orderHistoryHelper");
var _table = require("../../data/table");
var _decimalPlacesHelper = require("../../../helpers/decimalPlaces/decimalPlacesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClass = (0, _cssClassesHelper.getBEMClasses)('order-history-table');
var FilledOrdersComponent = function FilledOrdersComponent(props) {
  var t = props.t,
    selectedAccountId = props.selectedAccountId,
    getAccountTrades = props.getAccountTrades,
    resetActivePage = props.resetActivePage,
    data = props.data,
    instruments = props.instruments,
    config = props.config,
    fetching = props.fetching,
    selectedInstrument = props.selectedInstrument,
    futuresAccount = props.futuresAccount;
  var maxLines = config.maxLines,
    usePagination = config.usePagination;
  (0, _react.useEffect)(function () {
    if (selectedAccountId) {
      getAccountTrades(selectedAccountId, props.OMSId, 0);
    }
  }, [selectedAccountId, getAccountTrades, props.OMSId, maxLines]);
  (0, _react.useEffect)(function () {
    return function () {
      resetActivePage('FilledOrdersComponent');
    };
  }, [resetActivePage]);
  var columns = (0, _react.useMemo)(function () {
    return [{
      header: t('ID'),
      dataTest: 'ID',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref) {
        var row = _ref.row;
        return row.original.TradeId;
      }
    }, {
      header: t('Pair'),
      dataTest: 'Pair',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref2) {
        var row = _ref2.row;
        return row.original.instrument.Symbol;
      }
    }, {
      header: t('Side'),
      dataTest: 'Side',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref3) {
        var row = _ref3.row;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: baseClass(row.original.Side === 'Buy' ? 'buy' : 'sell')
        }, t(row.original.Side));
      }
    }, {
      header: t('Size'),
      dataTest: 'Size',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref4) {
        var row = _ref4.row;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: baseClass('size')
        }, row.original.Quantity && "".concat((0, _numberFormatter.formatNumberToLocale)(row.original.Quantity, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(row.original.selectedInstrument.QuantityIncrement)), " ").concat(row.original.selectedInstrument.Product1Symbol || ''));
      }
    }, {
      header: t('Price'),
      dataTest: 'Price',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref5) {
        var row = _ref5.row;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: baseClass('price')
        }, (0, _orderHistoryHelper.getOrderPriceToDisplay)(row.original, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(row.original.selectedInstrument.PriceIncrement)), ' ', row.original.selectedInstrument.Product2Symbol || '');
      }
    }, {
      header: t('Total'),
      dataTest: 'Total',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref6) {
        var row = _ref6.row;
        return (0, _numberFormatter.formatNumberToLocale)(row.original.Value, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(row.original.selectedInstrument.PriceIncrement));
      }
    }, {
      header: t('Fee'),
      dataTest: 'Fee',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref7) {
        var row = _ref7.row;
        var fee = futuresAccount ? row.original.Fee.amount : row.original.Fee;
        return "".concat((0, _numberFormatter.formatNumberToLocale)(fee, row.original.Fee.symbol), " ").concat(row.original.Fee.symbol);
      }
    }, {
      header: t('Execution ID'),
      dataTest: 'Execution ID',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref8) {
        var row = _ref8.row;
        return row.original.ExecutionId;
      }
    }, {
      header: t('Date/Time'),
      dataTest: 'Date/Time',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref9) {
        var row = _ref9.row;
        return (0, _dateHelper.formatDateTime)(new Date(row.original.TradeTimeMS));
      }
    }];
  }, [t, futuresAccount]);
  var dataWithInstruments = data.map(function (row) {
    return _objectSpread(_objectSpread({}, row), {}, {
      selectedInstrument: selectedInstrument || instruments.find(function (item) {
        return item.InstrumentId === row.InstrumentId;
      }) || {}
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_table.Table, {
    className: baseClass(),
    columns: columns,
    data: dataWithInstruments,
    stickyColumns: {
      right: ['Actions']
    },
    loading: fetching,
    emptyMessage: t('No data is available'),
    pagination: (0, _react.useMemo)(function () {
      return usePagination ? {
        pageSize: maxLines,
        variant: 'simple'
      } : undefined;
    }, [usePagination, maxLines]),
    scrollable: true
  });
};
FilledOrdersComponent.propTypes = {
  data: _propTypes["default"].array.isRequired,
  instruments: _propTypes["default"].array.isRequired,
  getAccountTrades: _propTypes["default"].func.isRequired,
  resetActivePage: _propTypes["default"].func.isRequired,
  config: _propTypes["default"].object.isRequired,
  fetching: _propTypes["default"].bool.isRequired,
  selectedAccountId: _propTypes["default"].string,
  selectedInstrument: _propTypes["default"].object,
  OMSId: _propTypes["default"].number
};
var FilledOrdersTranslated = (0, _reactI18next.withTranslation)('order')(FilledOrdersComponent);
// t('Filled Orders', { namespace: 'order' });
FilledOrdersTranslated.title = 'Filled Orders';
var _default = exports["default"] = FilledOrdersTranslated;